import { PlanPickerBody, PlanPickerResponse, OperationIds } from '../../../../API';
import { CreateDataManager, DataManagerReturnType } from '../../../DataManager';
import { PlanPickerHook, PlanPickerHookReturnType } from './PlanPickerHook';
import { PlanPickerState, PlanPickerStateReturnType } from './PlanPickerState';
import { usePlanPickerApi } from '../../../../hooks/API/PlanPicker/usePlanPickerApi';
import generateId from '../../../../utils/generateId';

export type PlanPickerDataManagerType = {
  state: PlanPickerStateReturnType;
  hook: PlanPickerHookReturnType;
};

export interface PlanPickerDataManagerReturnType extends DataManagerReturnType<PlanPickerResponse, PlanPickerBody> {
  state: PlanPickerStateReturnType;
  hook: () => PlanPickerHookReturnType;
}

export const PlanPickerDataManager = CreateDataManager<
  PlanPickerResponse,
  PlanPickerBody,
  PlanPickerDataManagerReturnType
>({
  name: 'PlanPicker',
  idField: 'id',
  stateInitializer: PlanPickerState,
  hookInitializer: PlanPickerHook,
  useApiHook: usePlanPickerApi,
  generateNew: (): PlanPickerBody => ({
    title: '',
    country: '',
    platforms: [],
    pricing: []
  }),
  toString: (planPicker: PlanPickerBody | PlanPickerResponse) => `${planPicker.title} - ${planPicker.country}`,
  generateEntityId: generateId,
  paginationLimit: 50,
  operationIdGetAll: OperationIds.GET_PAGINATED
});
